/**
 * Grid of persona cards for selection
 */

import type { Persona, PersonaId } from "../../types/persona";
import { PersonaCard } from "./PersonaCard";

interface PersonaSelectorProps {
  personas: Persona[];
  selectedId: PersonaId;
  onSelect: (personaId: PersonaId) => void;
  showDescriptions?: boolean;
  isLoading?: boolean;
}

export function PersonaSelector({
  personas,
  selectedId,
  onSelect,
  showDescriptions = false,
  isLoading = false,
}: PersonaSelectorProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="flex flex-col items-center p-4 rounded-md bg-surface-container animate-pulse"
          >
            <div className="w-20 h-20 rounded-full bg-surface-container-high mb-3" />
            <div className="w-16 h-4 bg-surface-container-high rounded mb-2" />
            <div className="w-24 h-3 bg-surface-container-high rounded" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {personas.map((persona) => (
        <PersonaCard
          key={persona.personaId}
          persona={persona}
          isSelected={selectedId === persona.personaId}
          onSelect={onSelect}
          showDescription={showDescriptions}
        />
      ))}
    </div>
  );
}
